import {
  useTranslate,
  IResourceComponentsProps,
  CrudFilters,
  HttpError,
} from "@pankod/refine-core";
import { useNavigation } from '../../core/customNavigation';

import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  Form,
  Input,
  Icons,
  Button,
  DeleteButton,
} from "@pankod/refine-antd";
import { IRoom } from "interfaces";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

export const RoomList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { show, list, create } = useNavigation()

  const { tableProps, sorter, searchFormProps } = useTable<IRoom, HttpError, IRoomFilterVariables>({
      onSearch: (params) => {
      const filters: CrudFilters = [];
      const { name } = params;
      filters.push(
          {
              field: "name",
              operator: "contains",
              value: name,
          },
      );
      return filters;
    },
    initialSorter: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });


  return (
    <List
      title={t("menu.rooms")}
      pageHeaderProps={{
        extra: [
          <Button key="page_header_extra_3" onClick={() => create(t("menu.rooms"))}>+</Button>,
          <Form 
            layout="horizontal"
            onValuesChange={() => searchFormProps.form?.submit()}
            key="page_header_extra_4"
            // size="small"
            {...searchFormProps}
          >
            <Form.Item label="" name="name" style={{ marginBottom: 0 }}>
              <Input
                  placeholder="ID, Title, Content, etc."
                  prefix={<Icons.SearchOutlined />}
              />
            </Form.Item>
          </Form>,

        ],
    }}

    >
      <Table
        {...tableProps} 
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
        }}
        rowKey="id"
      >
        <Table.Column
          dataIndex="name"
          key="name"
          title={t("rooms.room")}
          render={(value, record: IRoom) => <TextField value={value}/>}
          defaultSortOrder={getDefaultSortOrder("name", sorter)}
          sorter
        />

        <Table.Column
          dataIndex="guesty"
          key="guesty"
          title={t("Guesty")}
          render={(_: any, record: IRoom) => <>{record.guesty_room_id ? <CheckOutlined style={{color: "green"}} onClick={() => window?.open(`https://app.guesty.com/properties/${record.guesty_room_id}/monthly-calendar`, '_blank')}/> : <CloseOutlined style={{color: "red"}}/>}</>}
        />

        <Table.Column
          dataIndex="Pricezone"
          key="Pricezone"
          title={t("menu.pricezones")}
          render={(_: any, record: IRoom) => <>{record.pricezone ? <TextField value={record.pricezone.name} /> : <CloseOutlined style={{color: "red"}}/>}</>}
        />
        
        <Table.Column<IRoom>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};

interface IRoomFilterVariables {
  name: string;
}
